// @flow
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
// translit
import toTranslit from '../../util/cyrillic-to-translit';
// material
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { DefaultButton } from '../controls/button';
// Char counter
import TextCharCount from '../ui/charCounter';
// mutation
import * as TopicAddMutation from '../../mutations/TopicAddMutation';
import * as TopicEditMutation from '../../mutations/TopicEditMutation';
// style
import './topic-editor.css';

type Props = {
	topic: Object,
	relay: Object,
	history: Object,
};

type State = {
	id?: string,
	name: string,
	slug?: string,
	hidden: boolean,
	seoTitle?: string,
	seoDescription?: string,
	seoKeywords?: string,
};

const styleUnderline = {
	bottom: 5,
};

class TopicEditor extends React.Component<Props, State> {
	state = {
		name: '',
		slug: '',
		hidden: false,
		seoTitle: '',
		seoDescription: '',
		seoKeywords: '',
	};

	componentDidMount() {
		this.onMount(this.props.topic);
	}

	onMount(topic: Object) {
		if (topic) {
			this.setState({
				name: topic.name || '',
				slug: topic.slug || '',
				hidden: topic.hidden || false,
				seoTitle: topic.seoTitle || '',
				seoDescription: topic.seoDescription || '',
				seoKeywords: topic.seoKeywords || '',
			});
			if (topic.id) {
				this.setState({ id: topic.id });
			}
		}
	}

	onTitleChanged = (event: any, newValue: string) => {
		this.setState({
			name: newValue,
			slug: toTranslit(newValue),
		});
	};

	onSlugChanged = (newValue: string) => {
		this.setState({
			slug: toTranslit(newValue.replace(/[^a-zA-z0-9а-яА-Я -]/g, '')),
		});
	};

	save = (value: Object) => {
		const callback = (error: ?any, topicId: ?string) => {
			if (error != null) {
				alert(`error saving topic: ${error}`);
				return;
			}

			if (topicId) {
				this.props.history.replace(`/topic/${topicId}`);
			}
		};
		if (!this.state.slug) {
			this.onSlugChanged(this.state.name);
		}
		if (this.state.id) {
			TopicEditMutation.commit(this.props.relay.environment, value, error => callback(error));
		} else {
			TopicAddMutation.commit(this.props.relay.environment, value, '', (error, id) => callback(error, id));
		}
	};

	render() {
		return (
			<section className="topic-editor">
				<Paper className="topic-editor--wrapper">
					<h3 className="topic-editor--title">Тема</h3>
					<section className="topic-editor--fields">
						<TextField
							className="topic-editor--field"
							floatingLabelText="Название"
							value={this.state.name}
							maxLength="150"
							fullWidth
							errorText={this.state.name === null || this.state.name.length === 0 ? 'это поле нужно заполнить' : null}
							onChange={(event, value) => this.onTitleChanged(event, value)}
							floatingLabelFixed
							underlineStyle={styleUnderline}
						/>
						<TextCharCount maxChar={150} currentChar={this.state.name.length} />

						<TextField
							className="topic-editor--field"
							floatingLabelText="Slug"
							value={this.state.slug}
							maxLength="150"
							fullWidth
							errorText={this.state.slug === null || this.state.slug === '' ? 'это поле нужно заполнить' : null}
							onChange={(event, value) => this.onSlugChanged(value)}
							floatingLabelFixed
							underlineStyle={styleUnderline}
						/>
						<TextCharCount maxChar={150} currentChar={this.state.slug ? this.state.slug.length : 0} />

						<TextField
							className="topic-editor--field"
							floatingLabelText="SEO title"
							value={this.state.seoTitle}
							maxLength="140"
							fullWidth
							onChange={(e, v) => this.setState({ seoTitle: v })}
							floatingLabelFixed
							underlineStyle={styleUnderline}
						/>

						<TextField
							className="topic-editor--field"
							floatingLabelText="SEO description"
							value={this.state.seoDescription}
							fullWidth
							multiLine
							rows={1}
							rowsMax={4}
							onChange={(e, v) => this.setState({ seoDescription: v })}
							floatingLabelFixed
							underlineStyle={styleUnderline}
						/>

						<TextField
							className="topic-editor--field"
							floatingLabelText="SEO keywords"
							value={this.state.seoKeywords || ''}
							fullWidth
							onChange={(e, v) => this.setState({ seoKeywords: v })}
							floatingLabelFixed
							underlineStyle={styleUnderline}
						/>
					</section>
				</Paper>
				<aside className="topic-editor--sidebar">
					<div className="button__bottom">
						<SelectField
							floatingLabelText="Статус"
							value={this.state.hidden}
							onChange={(event, index, isChecked) => {
								this.setState({ hidden: isChecked });
							}}
						>
							<MenuItem value={false} primaryText="Видна" />
							<MenuItem value primaryText="Скрыта" />
						</SelectField>
						<DefaultButton onClick={() => this.save(this.state)} />
					</div>
				</aside>
			</section>
		);
	}
}

export default withRouter(
	createFragmentContainer(
		TopicEditor,
		graphql`
			fragment TopicEditor_topic on Topic {
				id
				name
				slug
				hidden
				seoTitle
				seoDescription
				seoKeywords
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/topics/TopicEditor.js